<template>
  <el-form
    :label-position="labelPosition"
    :label-width="labelWidthFilter"
    :model="model"
    :rules="rules"
    @submit.native.prevent="doFilter"
    class="filter"
    ref="form"
  >
    <el-row :gutter="16" class="filter__container"> 
      <!-- Id -->
      <el-col v-if="hasPermissionToAuditLogs" :lg="12" :md="16" :sm="24">
        <el-form-item
          :label="fields.id.label"
          :prop="fields.id.name"
        >
          <el-input v-model="model[fields.id.name]" />
        </el-form-item>
      </el-col>

      <!-- Name -->
      <el-col :lg="6" :md="16" :sm="24">
        <el-form-item :prop="fields.name.name">
          <div class="form__item__label__slot" slot="label">
            <span>{{fields.name.label}}</span>
            <el-button v-if="model.name" type="text" @click="resetFieldFilter({ fieldKey: 'name'})"><app-i18n code="common.reset"/></el-button>
          </div>
          <el-input
            clearable
            prefix-icon="icon-teams"
            :placeholder="fields.name.label"
            v-model="model[fields.name.name]"
            @input.native="debounceInput"
            @clear="doFilter"
          />
        </el-form-item>
      </el-col>

      <el-col v-if="hasPermissionToAuditLogs" :lg="12" :md="16" :sm="24" style="margin-bottom: -0.41px;">
        <el-form-item
          :label="fields.createdAtRange.label"
          :prop="fields.createdAtRange.name"
        >
          <el-date-picker type="datetimerange" v-model="model[fields.createdAtRange.name]"></el-date-picker>
        </el-form-item>
      </el-col>

      <!-- Filter buttons -->
      <el-col :lg="1" :md="16" :sm="24">
        <div class="filter-buttons">
          <el-button
            :disabled="loading"
            @click="doResetFilter"
            icon="icon-undo"
            circle
          />
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';
import { mapGetters, mapActions } from 'vuex';
import { FilterSchema } from '@shared/form/filter-schema';
import { TeamModel } from '@modules/team/team-model';
import _ from 'lodash';

const { fields } = TeamModel;

const filterSchema = new FilterSchema([
  fields.id,
  fields.name,
  fields.createdAtRange,
]);

export default {
  name: 'app-team-list-filter',

  data() {
    return {
      rules: filterSchema.rules(),
      model: {},
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthFilter: 'layout/labelWidthFilter',
      loading: 'team/list/loading',
      filter: 'team/list/filter',
    }),

    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },

    fields() {
      return fields;
    },
  },

  async mounted() {
    this.model = filterSchema.initialValues(
      this.filter,
      this.$route.query,
    );

    //return this.doFilter();
  },

  methods: {
    ...mapActions({
      doReset: 'team/list/doReset',
      doFetch: 'team/list/doFetch',
    }),

    async doResetFilter() {
      this.model = filterSchema.initialValues();
      this.$refs.form.clearValidate();
      return this.doReset();
    },

    async resetFieldFilter({ fieldKey }) {
      if (this.model[`${fieldKey}`]) this.model[`${fieldKey}`] = null;
      this.doFilter();
    },

    debounceInput: _.debounce(function () {
      this.doFilter();
    }, 500),

    async doFilter() {
      try {
        await this.$refs.form.validate();
        this.$refs.form.clearValidate();
      } catch (error) {
        return;
      }

      const filter = filterSchema.cast(this.model);
      return this.doFetch({
        filter,
      });
    },
  },
};
</script>

<style>
</style>
